module.exports = __webpack_public_path__ + "img/incar_mortgage_260417.d735f712.png";